<template>
  <v-card class="container">
    <div class="mb-2">
      <v-alert v-if="errorMsg" type="error" :value="true">
        {{ $t(errorMsg) || errorMsg }}
      </v-alert>
    </div>
    <form @submit="changePin">
      <div id="change-pin-card">
        <span class="close-button" @click="doAction('close')">
          <v-icon>close</v-icon>
        </span>
        <v-card-title>
          <h2>{{ $t('ChangePin.title') }}</h2>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="oldPin"
            :error="hasErrors"
            :label="$t('ChangePin.old')"
            @click:append=""
            :type="isOldPinVisibale ? 'text': 'password'"
            required
          >
            <template slot="append">
              <span class="visibility-button" @click="isOldPinVisibale = !isOldPinVisibale">
                <v-icon>{{isOldPinVisibale ? 'visibility_off' : 'visibility'}}</v-icon>
              </span>
            </template>
          </v-text-field>
          <v-text-field
            v-model="newPin"
            :error="hasErrors"
            :label="$t('ChangePin.new')"
            @click:append=""
            :type="isNewPinVisibale ? 'text': 'password'"
            required
          >
            <template slot="append">
              <span class="visibility-button" @click="isNewPinVisibale = !isNewPinVisibale">
                <v-icon>{{isNewPinVisibale ? 'visibility_off' : 'visibility'}}</v-icon>
              </span>
            </template>
          </v-text-field>
        </v-card-text>
        <v-card-actions class="text-md-center">
          <v-btn depressed large color="primary" class="mx-auto" :loading="isLoading" type="submit">
            {{ $t('Action.change') }} <v-icon class="ml-2">send</v-icon>
          </v-btn>
        </v-card-actions>
      </div>
    </form>
  </v-card>
</template>

<script>

  export default  {
    name: 'ChangePinInput',
    data: () => {
      return {
        oldPin: '',
        newPin: '',
        persist: false,
        errorMsg: '',
        isLoading: false,
        isOldPinVisibale: false,
        isNewPinVisibale: false,
      };
    },

    computed: {
      visibleIcon() {
        return this.$root.visibleIcon(this.isPinVisible);
      },
      hasErrors() {
        return this.errorMsg !== '';
      }
    },
    // mounted() {
    //   // console.log('REFS');
    //   // console.log(this.$refs);
    //   // this.$refs.oldPin.focus();
    // },

    methods: {
      changePin(event) {
        event.preventDefault();
        this.isLoading = true;

        this.$http
          .post(this.$root.route('account/pin'), {
            new: this.newPin,
            old: this.oldPin
          })
          .then(
            // Success
            response => {
              this.isLoading = false;
              this.doAction('success');
            },
            // Failure
            response => {
              this.isLoading = false;
              this.errorMsg = 'ChangePin.invalidOldPin';
            }
        );
      },
      doAction(actionName) {
        this.$emit('action', actionName);
      }
    }
  }

</script>

<style scoped>
  .container {
  }
  #change-pin-card {
    margin: auto 0;
    background: transparent;
  }
  .close-button {
    border-radius: 3px;
    cursor: pointer;
    user-select: none;
    float: right;
    padding: 16px;
  }
  .visibility-button {
    cursor: pointer;
    user-select: none;
  }
</style>
